import '../../sass/pages/_cbregisterEntrepreneurship.scss';

import * as Bouncer from "formbouncerjs";
import { emails } from "../config/constants";
import * as sha256 from "crypto-js/sha256";
import "swiper/css";
import 'animate.css';

declare global {
    interface Window {
        datalayer: any  
    }
}

const sendIdNode = () => {
    const arrayNode = window.drupalSettings.path.currentPath.split("/");

    fetch(`/set/co_clubco_convocatorias/evento/${arrayNode[1]}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then(response => response.json())
        .then((json) => { })
        .catch((err: any) => {
            console.log(err)
        });
}

const validationForm = () => {
    let bouncer = Bouncer("#entrepreneurship-form", {
        patterns: {
            email:
                /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
        },
        customValidations: {
            onlyLetter: (field: any) => {
                if (field.name == "name_owner") {
                    const value = field.value;
                    const pattern = new RegExp(
                        "^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+$",
                        "i"
                    );
                    // console.log(pattern.test(value))
                    if (!pattern.test(value)) return true;
                }
            },
            phoneVerified: function (field: any) {
                if (field.name == 'phone_entre') {
                    const value = field.value
                    if (value.length < 10 || value.length > 10) {
                        return true;
                    }
                }
            },
            instagramAccount: (field: any) => {
                if (field.name == 'instagram_entre') {
                    if (field.value == '@') return true;
                }
            },
            emailVerified: function (field: any) {
              if (field.name == "email") {
                let array_email = field.value.split("@");
                const res = emails.find((m: any) => m === array_email[1]);
                return res === undefined ? false : true;
              }
            },
        },
        messages: {
            missingValue: {
                checkbox:
                    "Este campo es obligatorio.",
                default: "Este campo es obligatorio",
            },
            patternMismatch: {
                email: "Por favor ingrese un email válido",
            },
            // onlyLetter: "Solo se permiten letras",
            phoneVerified: 'Solo se permiten 10 digitos',
            instagramAccount: 'Por favor ingresa la cuenta de emprendimiento',
            emailVerified: "Por favor ingrese un email válido",
        },
    });
}

const inputFile = () => {
    let container = document.querySelector('.js-form-type-file') as any;
    if (container) {
        let input = document.querySelector('.js-form-file') as any;
        container.innerHTML += `<div class="btn-text-file" style="${input.getAttribute('style')}"><span class="textNameFile">E.J. Cheese Cake Express.jpg</span><p style="${input.getAttribute('bgboton')}">Subir</p></div>`;
    }
    let nameFile = document.querySelector('#edit-photo') as any;
    if (nameFile) {
        nameFile.onchange = function () {
            let textName = document.querySelector('.textNameFile') as any;
            textName.innerHTML = nameFile.files[0].name;
        }
    }
}

const fillInstagramField = () => {
    let instagramField = document.querySelector('input.instagram') as HTMLInputElement;
    instagramField.addEventListener('input', (e: any) => {
        let nwText = !e.target.value.includes('@') ? `@${e.target.value}` : e.target.value
        instagramField.value = nwText
    })
}

const countDescription = () => {
    let descriptionWrapper = document.querySelector('.form-textarea-wrapper') as HTMLDivElement;
    descriptionWrapper.insertAdjacentHTML('beforeend', `
    <div class="description-count">
        <span id="total-characters">0</span>/<span id="max-characters">200</span>
    </div>
    `)
    let description = document.querySelector('#edit-description') as HTMLTextAreaElement;
    let totalChars: HTMLSpanElement | null;
    description.addEventListener('input', (e: any) => {
        if (!totalChars) totalChars = document.querySelector('#total-characters');
        if (totalChars) totalChars.innerHTML = `${e.target.value.length}`
    })
}

const validarCampoPhone = () => {
    document.querySelector('.entrepreneurship-form .js-form-item-phone-entre.has-error')?.parentElement?.classList.add('max49')
    const campoInput = document.querySelector('.entrepreneurship-form .js-form-item-phone-entre #edit-phone-entre');
    campoInput?.addEventListener('input', e => {
        const  msgError = document.querySelector('.entrepreneurship-form .boxerror-input .error-message');
        msgError?.classList.add('hidden')
        
    })
}

const sendDataLayer = () => {

    let btn = document.querySelector('.btnRegister') as any;
    if(btn){
        btn.addEventListener('click', function(){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Register',
                'event_action': 'Submit',
                'event_label': 'Form'
            });
        })
    }
}

(function page() {
    validationForm();
    inputFile();
    sendIdNode();
    fillInstagramField();
    countDescription();
    validarCampoPhone();
    sendDataLayer();
    const btnSubmit = document.querySelector('#edit-submit');
    if (btnSubmit) {
        btnSubmit.innerHTML = 'Registar <b>emprendimiento</b>';
    }
})()